import moment from 'moment';

import { MINORS_AMOUNT_KEY, MINORS_INBOUND_KEY, MINORS_OUTBOUND_KEY, MINORS_DATE_FORMAT } from 'constants/minors';
import { types as passengerTypes } from 'types/passengers';

export const getFirstNonCancelledSegmentIsoDate = (legs) => legs?.find(({ cancelled }) => cancelled === false)?.timing?.isoDate;

export const getMinorsAmount = (additionalDetails) => additionalDetails?.find((detail) => detail.key === MINORS_AMOUNT_KEY)?.value;

export const getPassengerTypeCounts = ({ passengers }) => {
  const passengerTypeCountMap = new Map(Object.values(passengerTypes).map((key) => [key, 0]));
  let total = 0;
  for (const { type } of passengers) {
    if (passengerTypeCountMap.has(type)) {
      passengerTypeCountMap.set(type, passengerTypeCountMap.get(type) + 1);
      total = total + 1;
    }
  }
  const passengerTypeCount = Object.fromEntries(passengerTypeCountMap);
  passengerTypeCount.total = total;
  return passengerTypeCount;
};

export const setMinors = async ({
  addAdditionalDetails,
  bookingReference,
  minors,
  minorsAmount,
  minorOutbound,
  minorInbound,
  updateAdditionalDetails
}) => {
  try {
    const additionalDetails = [];

    additionalDetails.push({
      key: MINORS_AMOUNT_KEY,
      value: minors
    });

    if (minorsAmount) {
      if (Number(minorsAmount) === Number(minors)) {
        return;
      }

      await updateAdditionalDetails({
        variables: {
          bookingReference,
          additionalDetails
        }
      });
      return;
    }

    if (minorOutbound) {
      const outboundDate = moment(minorOutbound);

      additionalDetails.push({
        key: MINORS_OUTBOUND_KEY,
        value: outboundDate.format(MINORS_DATE_FORMAT)
      });
    }

    if (minorInbound) {
      const inboundDate = moment(minorInbound);

      additionalDetails.push({
        key: MINORS_INBOUND_KEY,
        value: inboundDate.format(MINORS_DATE_FORMAT)
      });
    }

    await addAdditionalDetails({
      variables: {
        bookingReference,
        additionalDetails
      }
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
